import React from 'react';

function Veg(props) {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M20.4535 19.9999L17.1735 16.7199M3.02686 28.9332C3.02686 28.9332 16.1869 24.2665 20.0002 20.4532C20.5579 19.8964 21.0004 19.2352 21.3026 18.5074C21.6047 17.7795 21.7605 16.9993 21.7612 16.2113C21.7618 15.4232 21.6072 14.6427 21.3062 13.9144C21.0052 13.1861 20.5637 12.5242 20.0069 11.9665C19.4501 11.4089 18.7889 10.9663 18.061 10.6642C17.3332 10.362 16.553 10.2062 15.7649 10.2056C14.9768 10.2049 14.1964 10.3596 13.4681 10.6606C12.7398 10.9616 12.0779 11.4031 11.5202 11.9599C7.69352 15.7865 3.02686 28.9332 3.02686 28.9332ZM11.5202 18.6665L8.78686 15.9465L11.5202 18.6665Z"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="stroke-primary"
            />
            <path
                d="M29.3333 11.9997C29.3333 11.9997 27.56 9.33301 24.6667 9.33301C22.48 9.33301 20 11.9997 20 11.9997C20 11.9997 21.7733 14.6663 24.6667 14.6663C27.56 14.6663 29.3333 11.9997 29.3333 11.9997Z"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="stroke-primary"
            />
            <path
                d="M20.0002 2.6665C20.0002 2.6665 17.3335 4.43984 17.3335 7.33317C17.3335 10.2265 20.0002 11.9998 20.0002 11.9998C20.0002 11.9998 22.6668 9.5465 22.6668 7.33317C22.6668 4.43984 20.0002 2.6665 20.0002 2.6665Z"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="stroke-primary"
            />
        </svg>
    );
}

export { Veg };
